import { action } from '@reatom/framework'

import { pipe, Result } from '@blade/std-lib'
import { TelegramAuthToken, User } from '@root/entities/auth'
import { dependenciesAtom } from '@root/features/shared/dependencies'
import { apiRequest } from '@root/shared/api'

import type { TelegramAssignCreatePayload } from '@blade/trade-api-client'

export const assignTelegramRequestAction = action(
  async (ctx, req: TelegramAssignCreatePayload) => {
    const {
      tradeApiClient,
      environment: { assets },
    } = ctx.get(dependenciesAtom)

    const result = await ctx.schedule(() =>
      apiRequest(ctx, tradeApiClient.telegram.telegramAssignCreate, [req]),
    )

    return pipe(
      result,
      Result.map((dto) => User.fromDto(dto, assets.avatarsHost)),
    )
  },
  'assignTelegramRequestAction',
)

export const unassignTelegramRequestAction = action(async (ctx) => {
  const {
    tradeApiClient,
    environment: { assets },
  } = ctx.get(dependenciesAtom)

  const result = await ctx.schedule(() =>
    apiRequest(ctx, tradeApiClient.telegram.telegramUnassignCreate, []),
  )

  return pipe(
    result,
    Result.map((dto) => User.fromDto(dto, assets.avatarsHost)),
  )
}, 'unassignTelegramRequestAction')

export const generateTelegramTokenRequestAction = action(async (ctx) => {
  const { tradeApiClient } = ctx.get(dependenciesAtom)

  const result = await ctx.schedule(() =>
    apiRequest(ctx, tradeApiClient.user.userTgTokenCreate, []),
  )

  return pipe(
    result,
    Result.map((dto) => ({ ...dto, token: TelegramAuthToken(dto.token) })),
  )
}, 'generateTelegramTokenRequestAction')
